import { parsePhoneNumberFromString } from 'libphonenumber-js'
import stringToFloat from 'functions/string-to-float'
import cards from 'creditcards'

const validation = (value, controls = ['required']) => {
	let error = false;

	if (controls === true) {
		controls = [
			['required']
		];
	}
	// Shorthand for required message
	else if (typeof controls === 'string' || controls instanceof String) {
		controls = [
			['required', controls]
		];
	} else if (!Array.isArray(controls)) {
		controls = Object.keys(controls).map(function (objectKey, index) {
			let data = [controls[objectKey]];
			if (Array.isArray(data[0])) { data = data[0]; }
			return [objectKey, ...data];
		});
	}

	if(Array.isArray(value)){
		value = value.join(',');
	}

	controls.reverse();

	controls.map((control) => {
		let rerror;
		let key = control;
		let msg = false;
		let data = null;
		if (Array.isArray(control)) {
			key = control[0];
			msg = (control[1] !== true ? control[1] : undefined);
			if (control.length > 1) {
				data = control[2];
			}
		}

		if (validateRaw[key]) {
			if (data !== null) {
				rerror = validateRaw[key](msg, value, data);
			} else {
				rerror = validateRaw[key](msg, value);
			}
		}
		else { rerror = "Hatalı validation: " + key; }

		if (rerror !== undefined) {
			error = rerror;
		}

		return error;
	});

	return error;
}

const validateRaw = {
	'email': (msg = 'Geçerli bir e-posta adresi girmelisiniz.', value) => {
		let error;
		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
			error = msg;
		}
		return error;
	},
	'fullName': (msg = 'Geçerli bir isim girmelisiniz.', value) => {
		let error;
		let split = value.split(' ');
		if (/\d/.test(value) || split.length < 2 || split[0].length < 2 || split[1].length < 2 || value.replace(' ', '').length < 4) {
			error = msg;
		}
		return error;
	},
	'text': (msg = 'Bu alana yalnızca metin girebilirsiniz.', value) => {
		let error;
		if (/\d/.test(value)) {
			error = msg;
		}
		return error;
	},
	'phone': (msg = 'Geçerli bir telefon numarası girmelisiniz.', value) => {
		let error;

		let cleanVal = value ? value.replace(/\s/g,'') : '';
		//cleanVal = cleanVal ? (cleanVal.join('')) : '';

		if(!cleanVal.startsWith('+')){
			if(cleanVal.startsWith('00')){
				cleanVal = cleanVal.replace('00', '+');
			}
			else if(cleanVal.startsWith('0')) {
				cleanVal = '+9' + cleanVal;
			}
			else {
				cleanVal = '+90' + cleanVal;
			}
		}

		// +90 statik olarak eklendi
		const phoneNumber = parsePhoneNumberFromString(cleanVal);
		if (!(phoneNumber && phoneNumber.isValid())) {
			error = msg;
		}
		return error;
	},
	'id': (msg = 'Geçerli bir kimlik numarası girmelisiniz.', value) => {
		let error;
		if (!checkIDNum(value) && value !== '') {
			error = msg;
		}
		return error;
	},
	'taxOrID': (msg = 'Geçerli bir vergi veya kimlik numarası girmelisiniz.', value) => {
		let error;
		if (value && value.length && value !== '00000000000' && value !== '11111111111' && ((value.length === 11 && !checkIDNum(value)) || value.length < 10)) {
			error = msg;
		}
		return error;
	},
	'required': (msg = 'Bu alanı doldurmalısınız.', value) => {
		let error;
		if (!value || value === '') {
			error = msg;
		}
		return error;
	},
	'minNum': (msg = 'Bu alan {amount}\'den az olamaz.', value, amount, allowFormat = true) => {
		let error;
		if (allowFormat) { value = stringToFloat(value); }
		if (parseFloat(value) < amount) {
			error = msg.replace('{amount}', amount);;
		}
		return error;
	},
	'maxNum': (msg = 'Bu alan {amount}\'den fazla olamaz.', value, amount, allowFormat = true) => {
		let error;
		if (allowFormat) { value = stringToFloat(value); }
		if (parseFloat(value) > amount) {
			error = msg.replace('{amount}', amount);;
		}
		return error;
	},
	'minLength': (msg = 'Bu alana en az {length} karakter girmelisiniz.', value, length) => {
		let error;
		if (value && value.length < length) {
			error = msg.replace('{length}', length);;
		}
		return error;
	},
	'maxLength': (msg = 'Bu alana en fazla {length} karakter girebilirsiniz.', value, length) => {
		let error;
		if (value.length > length) {
			error = msg.replace('{length}', length);;
		}
		return error;
	},
	'length': (msg = 'Bu alana {length} karakter girmelisiniz.', value, length) => {
		let error;
		if (value.length !== length) {
			error = msg.replace('{length}', length);;
		}
		return error;
	},
	'minWords': (msg = 'Bu alana en az {length} kelime girmelisiniz', value, length) => {
		let error;
		if (value.trim().split(' ').length < length) {
			error = msg.replace('{length}', length);;
		}
		return error;
	},
	'maxWords': (msg = 'Bu alana en fazla {length} kelime girebilirsiniz.', value, length) => {
		let error;
		if (value.trim().split(' ').length > length) {
			error = msg.replace('{length}', length);;
		}
		return error;
	},
	'compare': (msg = 'Alanlar uyuşmuyor.', value, compare) => {
		let error;
		let compareItem = document.querySelector(compare);
		if (!compareItem || compareItem.value !== value) {
			error = msg;
		}
		return error;
	},
	'fileRequired': (msg = 'Bu alanı doldurmalısınız.', files) => {
		let error;
		if (!files.length) {
			error = msg;
		}
		return error;
	},
	'fileSize': (msg = 'Dosya boyutu en fazla {maxSize} olabilir.', files, maxSize = 1024) => {
		let error;
		for(let file of files) {
			if (file.size > (maxSize * 1024)) {
				let maxText = maxSize < 1024 ? maxSize + 'kb' : Math.round(maxSize / 1024) + 'mb';
				error = msg.replace('{maxSize}', maxText);
			}
		}
		return error;
	},
	'fileFormat': (msg = '{fileType} uzantılı dosya yükleyemezsiniz.', files, types = ['image/jpeg', 'image/png', 'image/gif']) => {
		let error;
		for(let file of files) {
			if(types.indexOf(file.type) < 0) {
				let extension = file.name.split('.');
				extension = extension[extension.length - 1].toLowerCase();
				error = msg.replace('{fileType}', ('".' + extension + '"'));
			}
		}
		return error;
	},
	'date': (msg = 'You must enter a valid date.', value) => {
		let error;
		if (!value) {
			error = msg;
		}
		return error;
	},
	'cvv': (msg = 'Geçerli bir CVV numarası girmelisiniz.', value, type = false) => {
		let error;
		if (!cards.cvc.isValid(value, type)) {
			error = msg;
		}
		return error;
	},
	'expiry': (msg = 'Geçerli bir son kullanma tarihi girmelisiniz.', dateString, gaps = false) => {
		let error;

		var curYear = parseInt((new Date()).getFullYear().toString().substr(-2));
		var month = 13;
		var year = 1;
		var dateReg = new RegExp((gaps ? /[0-9]{1,2} \/ [0-9]{1,2}/ : /[0-9]{1,2}\/[0-9]{1,2}/));
		if (dateReg.test(dateString)) {
			var parts = dateString.split((gaps ? ' / ' : '/'));
			month = parseInt(parts[0], 10);
			year = parseInt(parts[1], 10);
		}

		if (month > 12 || year < 19 || year < (curYear)) {
			error = msg;
		}

		return error;
	},
	'creditCard': (msg = 'Geçerli bir kart numarası girmelisiniz.', value) => {
		let error;
		if (!cards.card.isValid(value.replace(/\D/g,''))) {
			error = msg;
		}
		return error;
	},
	'url': (msg = 'Geçerli bir URL girmelisiniz.', value, strict = true) => {
		let error;
		if(value && value.length) {
			var pattern = new RegExp((strict ? '^(https?:\\/\\/)' : '^(https?:\\/\\/)?')+ // protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
				'(\\#[-a-z\\d_]*)?$','i'); // fragment locator;
			if(!pattern.test(value)){
				error = msg;
			}
		}
		return error;
	},
	'iban': (msg = 'Geçerli bir IBAN girmelisiniz.', value) => {
		let error;
		if(value && value.length && !value.split(' ').join('').match(/^[A-Z]{2}[0-9]{24}$/)){
			error = msg;
		}
		return error;
	},
}

function checkIDNum(tcno) {
	tcno = String(tcno);
	let j = 0;
	let i = 0;
	let hane_tek = 0;
	let hane_cift = 0;

	if (tcno.substring(0, 1) === '0') {
		return false;
	}
	if (tcno.length !== 11) {
		return false;
	}
	let ilkon_array = tcno.substr(0, 10).split('');
	let ilkon_total = hane_tek = hane_cift = 0;

	for (i = j = 0; i < 9; ++i) {
		j = parseInt(ilkon_array[i], 10);
		if (i & 1) { // tek ise, tcnin çift haneleri toplanmalı!
			hane_cift += j;
		} else {
			hane_tek += j;
		}
		ilkon_total += j;
	}
	if ((hane_tek * 7 - hane_cift) % 10 !== parseInt(tcno.substr(-2, 1), 10)) {
		return false;
	}
	ilkon_total += parseInt(ilkon_array[9], 10);
	if (ilkon_total % 10 !== parseInt(tcno.substr(-1), 10)) {
		return false;
	}
	return true;
};

export default validation